import React from "react";
import ThinkingBgLanding from "./ThinkingBgLanding";
import ThinkingHeading from "./ThinkingHeading";
import { Box } from "@mui/material";
import ThinkingCardSection from "./ThinkingCardSection";
import { Helmet } from "react-helmet";

const Thinking = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | Thinking</title>
        <meta
          name="description"
          content="The relevance of the title is high because AI appears to be the ultimate enabler of the corporate world, and the CEO is the ultimate decision-maker of that world."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <ThinkingBgLanding />
        <ThinkingHeading />
        <ThinkingCardSection />
      </Box>
    </>
  );
};

export default Thinking;
